import React, { useEffect, useState } from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const LoadingPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {
    // Extract values from URL (userId, username, activityInstance)
    const pathArray = window.location.pathname.split('/');
    const userId = pathArray[2]; // Example: 40693
    const username = pathArray[3]; // Example: jahnavivb
    const userEmail = pathArray[4]; // Example: jahnavivb
    const activityInstance = pathArray[5]; // Example: 9905

    // Clear existing localStorage and sessionStorage values
    localStorage.clear();
    sessionStorage.clear();

    // Store new values in localStorage
    localStorage.setItem('userid', userId);
    localStorage.setItem('username', username);
    localStorage.setItem('userEmail', userEmail);

    // Store activityInstance and other values in sessionStorage
    sessionStorage.setItem('activityInstance', activityInstance);
    sessionStorage.setItem('userid', userId);
    sessionStorage.setItem('username', username);
    sessionStorage.setItem('userEmail', userEmail);

    // Fetch exercises
    fetchExercises(activityInstance);
  }, []);

  // Fetch exercise data based on courseId (or activityInstance in this case)
  const fetchExercises = async activityInstance => {
    if (activityInstance !== 'T1234') {
      setIsLoading(true);

      try {
        // const exercise = await dispatch(
        //   fetchExerciseByCourseIdAsync(baseURLs.core_course_get_contents + '2019')
        // ).unwrap(); // Unwraps the promise returned by dispatch
        // setExerciseData(exercise);
        // console.log(exercise);

        // After fetching the exercise data, navigate to the courses page
        navigate('/courses'); // Redirect to the courses page
      } catch (error) {
        console.error('Error fetching exercises:', error);
      }

      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
      {isLoading ? (
        // Loading Spinner
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Loading...</Typography>
        </Box>
      ) : (
        // Render a simple message or nothing when not loading
        <Typography variant="h6">Redirecting to courses...</Typography>
      )}
    </Box>
  );
};

export default LoadingPage;
